/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      document.querySelectorAll( '.btn-primary, .btn-primary-white' ).forEach( ( btn ) => {
        // Skip if it's already been updated
        if ( btn.querySelector( '.btn-primary__label' ) ) return;

        // Create wrapper span
        const label = document.createElement( 'span' );
        label.classList.add( 'btn-primary__label' );

        // Move only text nodes into wrapper
        [...btn.childNodes].forEach( ( node ) => {
          if ( node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '' ) {
            label.appendChild( node );
          }
        } );

        // Insert at the front before icons/etc.
        btn.prepend( label );
      } );


      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( 'body, html' ).toggleClass( 'is-nav-open' );
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.primary-nav__parent-item' ).on( 'toggleAfter', ( event ) => {
        $( event.target ).next().slideToggle();
      } );

      $( '.primary-nav__parent-item' ).on( 'toggleAfter', ( event ) => {
        if ( window.easyToggleState.isActive( event.target ) ) {
          $( $( event.target ).attr( 'data-dropdown-id' ) ).slideToggle();
        } else {
          $( $( event.target ).attr( 'data-dropdown-id' ) ).slideToggle();
        }
      } );

      $( '.blog__sidebar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.blog__sidebar-inner' ).slideToggle();
      } );

      $( '.btn-primary, .btn-primary-white, .llgq-quoter-next, .button.primary-btn' ).each( function() {
        $( this ).prepend( '<span class="icon-wrapper"><svg class="icon icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg></span>' );
      } );

      $( '.btn-secondary, .btn-secondary-white, .button.primary-btn' ).each( function() {
        $( this ).append( '<span class="icon-wrapper"><svg class="icon icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg></span>' );
      } );

      $( '.single-ll_course' ).each( function( index, element ) {
        const overlay = $( element ).find( '.banner-image__overlay' );
        const content = $( element ).find( '.banner-image__content' );
        const contentHeight = $( content ).outerHeight();

        gsap.set( overlay, {opacity: 0} );
        gsap.set( content, {y: `${contentHeight}px`} );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: $( element ),
            pin: true,
            anticipatePin: 0.5,
            once: true,
            onLeave: ( self ) => {
              const start = self.start;
              self.scroll( self.start );
              self.disable();
              self.animation.progress( 1 );
              ScrollTrigger.refresh();
              window.scrollTo( 0, start );
            },
            scrub: 0.5,
            start: 'top top',
            end: 'bottom 70%',
          },
        } );

        tl.to( $( overlay ), {
          opacity: 0.5, // property/value
          duration: 0.75, // duration e.g. 1s
        }, 0 );

        tl.to( $( content ), {
          y: 0, // property/value
          duration: 1.5, // duration e.g. 1s
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      } );

      // Sets alertBarHeight css variable
      const setNavbarHeight = ( ) => {
        const navbarHeight = $( '.navbar' ).outerHeight();
        const topHeight = Math.ceil( $( '.navbar-top' ).outerHeight() );
        const bottomHeight = Math.ceil( $( '.navbar-primary' ).outerHeight() );

        if ( navbarHeight < ( bottomHeight + topHeight ) ) {
          $( ':root' ).get( 0 ).style.setProperty( '--navbarHeight', `${( bottomHeight + topHeight )}px` );
        }
      };


      function debounce( func, timeout = 300 ) {
        let timer;
        return ( ...args ) => {
          clearTimeout( timer );
          timer = setTimeout( () => {
            func.apply( this, args );
          }, timeout );
        };
      }

      setNavbarHeight();

      $( window ).on( 'resize', debounce( function() {
        setNavbarHeight();
      } ) );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 1270px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      // lazy loads background images in css
      const lazyBackgrounds = [].slice.call( document.querySelectorAll( '.lazy-background' ) );

      if ( 'IntersectionObserver' in window ) {
        const lazyBackgroundObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( entry ) {
            if ( entry.isIntersecting ) {
              entry.target.classList.add( 'is-visible' );
              lazyBackgroundObserver.unobserve( entry.target );
            }
          } );
        } );

        lazyBackgrounds.forEach( function( lazyBackground ) {
          lazyBackgroundObserver.observe( lazyBackground );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
